import * as ActionTypes from "../../actions";
import status from "./status";

//Updates the status apiCalls data for different api call.
var aiUserApiCalls = {
  fetchAiUsersByEnabledAtNotNullOrderByGroupMembersCountDesc: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_REQUEST, ActionTypes.GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_SUCCESS, ActionTypes.GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_FAILURE, ActionTypes.RESET_GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC]
  }),
  postAiUserQuestion: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.POST_AIUSERQUESTION_REQUEST, ActionTypes.POST_AIUSERQUESTION_SUCCESS, ActionTypes.POST_AIUSERQUESTION_FAILURE, ActionTypes.RESET_POST_AIUSERQUESTION]
  }),
  postAiUserInvestmentPlan: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.POST_AIUSERINVESTMENTPLAN_REQUEST, ActionTypes.POST_AIUSERINVESTMENTPLAN_SUCCESS, ActionTypes.POST_AIUSERINVESTMENTPLAN_FAILURE, ActionTypes.RESET_POST_AIUSERINVESTMENTPLAN]
  })
};
export default aiUserApiCalls;